<template>
  <div>
    <FlashMessage v-if="messages.text !== ''" :message="messages" />
    <form
      @submit.prevent="handleSubmit"
      ref="resetTemplate"
      class="bg-gray-200 p-4 rounded-xl"
    >
      <h1 class="text-1xl font-bold mb-2" style="color: #1a2e5a">
        {{ isEditMode ? "Edit Template" : "Add Template" }}
      </h1>

      <div class="bg-white rounded-md shadow-sm p-4 mb-4">
        <div class="flex flex-col md:flex-row gap-3 items-center">
          <div class="md:w-1/4 w-full">
            <input
              v-model="campaignName"
              type="text"
              required
              placeholder="Template Title"
              class="w-full bg-gray-100 rounded px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-300"
            />
          </div>

          <div class="w-full md:flex-1">
            <input
              v-model="subject"
              type="text"
              required
              placeholder="Subject"
              class="w-full bg-gray-100 rounded px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-300"
            />
          </div>

          <div class="md:w-1/5 w-full">
            <select
              v-model="type"
              required
              class="w-full bg-gray-100 rounded px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-300"
            >
              <option value="event">Event</option>
            </select>
          </div>
        </div>
      </div>

      <div class="flex justify-between">
        <button
          type="submit"
          :disabled="disable_submit"
          class="rounded-lg text-sm px-6 py-2 flex items-center gap-2 transition-all ml-auto"
          :class="
            disable_submit
              ? 'bg-gray-300 cursor-not-allowed text-black'
              : 'bg-blues hover:bg-[#18469d] text-white'
          "
        >
          <span
            v-if="disable_submit"
            class="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"
          ></span>

          {{
            disable_submit
              ? isEditMode
                ? "Updating..."
                : "Saving..."
              : isEditMode
              ? "Update"
              : "Save"
          }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: { FlashMessage },

  props: {
    campaignData: {
      type: Object,
      default: null,
    },
    campaignSlug: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      messages: {
        text: "",
        type: null,
      },
      disable_submit: false,
      campaignName: "",
      subject: "",
      type: "event",
      isEditMode: false,
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  watch: {
    campaignData: {
      immediate: true,
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.campaignName = newData.title || "";
          this.subject = newData.content || "";
          this.type = newData.event || "event";
          this.isEditMode = true;
        } else {
          this.campaignName = "";
          this.subject = "";
          this.type = "event";
          this.isEditMode = false;
        }
      },
    },
  },

  methods: {
    async handleSubmit() {
      if (this.disable_submit) return;
      this.disable_submit = true;

      if (this.isEditMode && this.campaignData) {
        await this.updateTemplate();
      } else {
        await this.createTemplate();
      }
    },

    async createTemplate() {
      const payload = {
        title: this.campaignName,
        content: this.subject,
        event: this.type,
        step_1: true,
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/email-campaign/create/?Key=${this.userInfo.token_key}`,
          payload,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };

          setTimeout(() => {
            this.$emit("campaignCreated", response.data.data.slug);
            this.disable_submit = false;
          }, 800);
        } else {
          this.handleError(response.data.message);
        }
      } catch (error) {
        console.error("Creation failed:", error);
        this.handleError("Failed to create template");
      }
    },

    async updateTemplate() {
      const payload = {
        title: this.campaignName,
        content: this.subject,
        event: this.type,
      };

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/email-campaign-update/${this.campaignSlug}/?Key=${this.userInfo.token_key}`,
          payload,
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message || "Template updated successfully",
            type: "success",
          };

          setTimeout(() => {
            this.$emit("campaignUpdated", this.campaignSlug);
            this.disable_submit = false;
          }, 800);
        } else {
          this.handleError(response.data.message);
        }
      } catch (error) {
        console.error("Update failed:", error);
        this.handleError("Failed to update template");
      }
    },

    handleError(message) {
      this.disable_submit = false;
      this.messages = {
        text: message || "Operation failed",
        type: "error",
      };

      setTimeout(() => {
        this.messages = { text: "", type: null };
      }, 1500);
    },
  },
};
</script>
